export default {
  apiKey: 'AIzaSyDdpa7lDiJuYUmyKyY3rtMD9iAsDjZVJqc',
  authDomain: 'intrinotify.firebaseapp.com',
  databaseURL: 'https://intrinotify.firebaseio.com',
  projectId: 'intrinotify',
  storageBucket: 'intrinotify.appspot.com',
  messagingSenderId: '80140852661'
}



// WEBPACK FOOTER //
// ./src/firebaseRef.js